import React, { useState, useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';

const CertificateCard = ({ certificate }) => {
  const [showMore, setShowMore] = useState({});

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

    
  const toggleShowMore = (id) => {
    setShowMore((prevState) => ({ ...prevState, [id]: !prevState[id] }));
  };

  return (
    <div className="card bg-[#515151] text-white font-inria p-4 rounded-xl shadow-md" data-aos="fade-right">
      <img src={certificate.imageUrl} alt={certificate.title} className="w-full h-48 object-cover rounded-xl" />
      <div className="p-4">
        <h2 className="text-lg font-semibold">{certificate.title}</h2>
        <p className="text-sm mt-2 text-black">{showMore[certificate._id] ? certificate.description : `${certificate.description.substring(0, 100)}...`}
                    <button
                      onClick={() => toggleShowMore(certificate._id)}
                      className="text-[#E4B379] ml-2"
                    >
                      {showMore[certificate._id] ? 'Show less' : 'Show more'}
                    </button>
                    </p>
        <a href={certificate.imageUrl} target="_blank" rel="noopener noreferrer">
          <button className="mt-4 px-8 py-1 border-[#E4B379] border bg-[#515151] shadow-md shadow-[#E4B379] text-white rounded-full hover:bg-[#E4B379] hover:text-black hover:shadow-transparent transition-colors">
            View Certificate
          </button>
        </a>
      </div>
    </div>
  );
};

const CertificateCardGrid = ({ displayCount, gridTemplate }) => {
  
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCertificates = async () => {
      try {
        const response = await fetch('https://sirichandhanak-backend.vercel.app/api/certificates');
        if (!response.ok) {
          throw new Error('Failed to fetch certificates');
        }
        const data = await response.json();
        const sortedData = data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setCertificates(sortedData);
      } catch (error) {
        console.error('Error fetching certificates:', error);
      }
    };

    fetchCertificates();

    const loadingTimeout = setTimeout(() => {
      setLoading(false);
    }, 2000); // Adjust the number of milliseconds for the loading duration

    return () => clearTimeout(loadingTimeout);
  }, []);
  

  const getPlaceholderCount = () => {
    if (gridTemplate.includes('md:grid-cols-2')) return 2;
    if (gridTemplate.includes('md:grid-cols-3')) return 3;
    return 1; // Default to 1 if gridTemplate doesn't match specific conditions
  };

  if (loading) {
    return (
      <div className={`grid gap-6 p-4 ${gridTemplate}`}>
        {Array(getPlaceholderCount()).fill(0).map((_, index) => (
          <div key={index} className="bg-[#515151] p-6 rounded-lg animate-pulse">
            <div className="h-48 bg-gray-500 rounded mb-4"></div>
            <div className="h-4 bg-gray-500 rounded mb-4"></div>
            <div className="h-16 bg-gray-500 rounded mb-4"></div>
            <div className="h-8 bg-gray-500 rounded"></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={`grid gap-6 p-4 ${gridTemplate}`}>
      {certificates.slice(0, displayCount).map((certificate, index) => (
        <CertificateCard 
          key={index}
          certificate={certificate}
        />
      ))}
    </div>
  );
};


export default CertificateCardGrid;
